import { NgModule } from '@angular/core';
import { AutoscalingFormFieldComponent } from './autoscaling-form-field.component';

@NgModule({
  imports: [
    AutoscalingFormFieldComponent
  ],
  exports: [ AutoscalingFormFieldComponent ]
})
export class ZuiAutoscalingFormFieldModule {

}
